import { CustomStyleSheet } from '../../../utils/rn/tools';
export default CustomStyleSheet({
  popupContentContainer: {
    borderTopRightRadius: 12,
    borderTopLeftRadius: 12
  },
  popupTitleStyle: {
    height: 48,
    paddingTop: 14,
    paddingBottom: 14
  },
  popupTitleContainerStyle: {
    height: 48,
    borderBottomWidth: 0
  },
  popupContent: {
    padding: 0,
    paddingBottom: 20,
    height: 600
  },
  inputWrapperStyle: {
    backgroundColor: '#F5F5F5',
    borderWidth: 0,
    borderRadius: 2,
    height: 36
  },
  inputContentStyle: {
    paddingLeft: 28,
    marginTop: 10
  },
  clearIconConainerStyle: {
    top: 10
  },
  searchIconContainerStyle: {
    top: 10
  },
  popupContentContainerStyle: {
    minHeight: 600
  },
  productSelectWithSearch: {
    flex: 1
  },
  searchContainer: {
    marginHorizontal: 12,
    marginBottom: 8
  },
  titleStyle: {
    padding: 0,
    paddingVertical: 10
  },
  titleWithUnderStyle: {
    marginHorizontal: 12
  },
  titleContainerStyle: {
    borderBottomWidth: 0.5,
    borderBottomColor: 'rgba(0, 0, 0, 0.09)'
  }
});